import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'devextreme/data/odata/store';
import { useHistory } from "react-router-dom";
import DataGrid, {
    Column,
    Paging,
    FilterRow,
    Editing,
    HeaderFilter,
    SearchPanel,
    RequiredRule,
    Selection,
    FilterPanel
} from 'devextreme-react/data-grid';
import TenantService from "../../api/tenant.service";
import EntityService from "../../api/entity.service";
import AssetsService from "../../api/assets.service";
import DevicesService from "../../api/devices.service";
import GatewayService from '../../api/gateway.service';
import SpacesService from "../../api/spaces.service";
import Toast from 'components/Toast';
import { Popup as Popup2 } from 'devextreme-react/popup';
import SelectBox from 'devextreme-react/select-box';
import './entityGroup.css'
import ScrollView from 'devextreme-react/scroll-view';
import { Form as Form2 } from 'devextreme-react/form'
import { Item as Item2 } from 'devextreme-react/form';
import { CheckBox } from 'devextreme-react';
import { Tooltip } from 'devextreme-react/tooltip';
import TextBox, { TextBoxTypes } from 'devextreme-react/text-box';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer';

function rulesText() {
    return <i className="dx-icon-edit" style={{ fontSize: "16px", color: "#d71109" }}></i>;
}

const EntitiesGrid = React.memo(({ data, onRowInserted, onRowRemoved }) => {
    return (
        <DataGrid
            id="entity-group-map-grid"
            // height={'calc(100vh - 525px)'}
            // height={height}
            ref={undefined}
            showColumnLines={false}
            showRowLines={true}
            onRowInserted={onRowInserted}
            onRowRemoved={onRowRemoved}
            allowColumnResizing={true}
            dataSource={data}>
            <Paging enabled={false} />
            <Editing
                allowDeleting={true}
                use-icons={true}
                texts={{
                    // addRow: 'Add an Entity',
                    confirmDeleteMessage: "Are you sure you want to delete this Entity?"
                }}
            >
            </Editing>
            <FilterRow visible="true" apply-filter="true" />
            <HeaderFilter visible="showHeaderFilter" />
            <SearchPanel visible="true" width="240" placeholder="Search..." />
            <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
            <Column
                dataField={'name'}
                caption={"Entity Name"}
            >
                <RequiredRule />
            </Column>
            <Column dataField="type" />
        </DataGrid>
    );
});

export default function App(props) {
    const history = useHistory();
    const entityGroupId = props.match.params.entityGroupId
    const [height, setHeight] = useState(0);
    const [data, setData] = useState([])
    const [dataRule, setDataRule] = useState([])
    const [listData, setListData] = useState([])
    const [selectedItems, setSelectedItems] = useState([])
    const [popupVisible2, setPopupVisible2] = useState(false)
    const [behaviorPopupVisible, setbehaviorPopupVisible] = useState(false)
    const [popupVisibleRule, setPopupVisibleRule] = useState(false)
    const [ruleType, setRuleType] = useState(null)
    const [pageName, setPageName] = useState("")
    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000
    });
    const tenant = TenantService.getTenant()
    const dropDataGridRef = useRef()

    // rules of behavior

    const dropDataGridRefRule = useRef()
    const [popupData, setPopupData] = useState({
        editId: null,
        editAdd: "add",
        transmitPeriodHours: null,
        reTransmitPeriodHours: null,
        processState: null,
        thresholdHours: null,
        thresholdMinutes: null,
        detectionType: null,
        ruleType: null,
        name: null,
        selectedSpace2: [],
        createNotification: true,
        entityNotes: "",
        severity: null,
        batteryLevel: null,
        directionExcursion: null,
        suppressionWindow: null,
        temperatureThreshold: null,
        temperatureUnit: 1,
        formVisible: false
    })
    const [formVisible, setFormVisible] = useState(false)
    const [spaces, setSpaces] = useState([])
    const [batteryData, setBatteryData] = useState([])
    // const [selectedSpace2, setSelectedSpace2] = useState()

    // const [suppressionWindow, setSuppressionWindow] = useState()
    // const [directionExcursion, setDirectionExcursion] = useState()
    // const [temperatureThreshold, setTemperatureThreshold] = useState()
    // const [temperatureUnit, setTemperatureUnit] = useState(1)

    // const [transmitPeriodHours, setTransmitPeriodHours] = useState()
    // const [reTransmitPeriodHours, setReTransmitPeriodHours] = useState()
    // const [thresholdHours, setThresholdHours] = useState()
    // const [processState, setProcessState] = useState()
    // const [thresholdMinutes, setThresholdMinutes] = useState()
    // const [createNotification, setCreateNotification] = useState(true)
    const [offsite, setOffsite] = useState(true)
    // const [batteryLevel, setBatteryLevel] = useState()
    const [severityLabel, setSeverityLabel] = useState()
    // const [severity, setSeverity] = useState(null)
    // const [detectionType, setDetectionType] = useState()
    const [ruleLabel, setRuleLabel] = useState()
    // const [name, setName] = useState()
    const [behaviorName, setBehaviorName] = useState()
    // const [editAdd, setEditAdd] = useState("add")
    // const [editId, setEditId] = useState()
    // const [entityNotes, setEntityNotes] = useState("")
    const reTransmitPeriodHoursLabel = {
        text: 'Retransmit period [hours]'
    }

    const processStateLabel = {
        text: 'New Process State'
    }

    const thresholdHoursLabel = {
        text: 'Threshold time [hours]'
    }

    // const handleResize = () => {
    //     const newHeight = window.innerHeight - 525; // Adjust according to your layout
    //     setHeight(newHeight);
    //   };

    //   useEffect(() => {
    //     handleResize();
    //     window.addEventListener('resize', handleResize);
    //     return () => {
    //       window.removeEventListener('resize', handleResize);
    //     };
    //   }, []);

    function getData() {
        EntityService.getEntitiesInGroup(entityGroupId).then((value) => {
            setData(value.data.data.entities)
            setPageName(value.data.data.groupName)
            setBehaviorName(value.data.data.groupName)
        })
    }

    const onRowInserted = useCallback((e) => {
        EntityService.createEntityGroup(e.data.name).then(() => getData());
    }, []);

    const onRowRemoved = useCallback((e) => {
        EntityService.deleteEntityGroupMap([e.data.entityId], entityGroupId).then((response) => {
            getData();
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response.status,
                message: response.data.message,
            });
        });
    }, []);


    function closeTenant() {
        history.push("/config/behaviors");
    }

    function openBehaviorEditPopup() {
        setBehaviorName(pageName) // Ensure we start with current page name
        setbehaviorPopupVisible(true)
    }

    function onOptionChanged(e) {
        setSelectedItems(e.selectedRowKeys)
    }

    function createGroupMapEntities() {
        let result1 = selectedItems.map(a => a.id);
        EntityService.createEntityGroupMap(result1, entityGroupId).then((response) => {
            getData()
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response.status,
                message: response.data.message,
            });
        })
        setPopupVisible2(false)
    }

    function addOnClick() {
        // Reset state when opening entities drawer
        // setRuleType("")
        setPopupData(prev => ({ ...prev, ruleType: "" }))
        setListData([])
        setSelectedItems([])
        setPopupVisible2(true)
    }

    function onEntitySelection(e) {
        console.log('hello');

        // setRuleType(e.value)
        setPopupData(prev => ({ ...prev, ruleType: e.value }))
        if (e.value === 'Gateways') {
            GatewayService.getGateways().then((value) => {
                setListData(value.data.data)
            })
        }
        if (e.value === 'Assets') {
            AssetsService.getAssets(tenant).then((value) => {
                setListData(value.data.data)
            })
        }
        if (e.value === 'Devices') {
            DevicesService.getDevices(tenant).then((value) => {
                let response = value.data
                setListData(response.data)
            })
        }
    }

    useEffect(() => {
        getData()
    }, []);




    function getSpaceData() {
        SpacesService.getSpaces(tenant).then((value) => {
            let response = value.data
            setSpaces(response.data)
        })
    }

    function onValueChanged2(e) {
        // setSelectedSpace2(e.value)
        setPopupData(prev => ({ ...prev, selectedSpace2: e.value }))

    }
    function onSuppressionWindow(e) {
        // setSuppressionWindow(e.value)
        setPopupData(prev => ({ ...prev, suppressionWindow: e.value }))
    }

    function onTemperatureThreshold(e) {
        // setTemperatureThreshold(e.value)
        setPopupData(prev => ({ ...prev, temperatureThreshold: e.value }))
    }

    function onDirectionExcursion(e) {
        // setDirectionExcursion(e.value)
        setPopupData(prev => ({ ...prev, directionExcursion: e.value }))
    }

    function onTemperatureUnit(e) {
        // setTemperatureUnit(e.value)
        setPopupData(prev => ({ ...prev, temperatureUnit: e.value }))
    }

    function onValueChangedBattery(e) {
        // setBatteryLevel(e.value)
        setPopupData(prev => ({ ...prev, batteryLevel: e.value }))
    }

    function onValueChangedDetection(e) {
        // setDetectionType(e.value)
        setPopupData(prev => ({ ...prev, detectionType: e.value }))

    }

    function updateCheckBoxValue(e) {
        // setCreateNotification(e)
        setPopupData(prev => ({ ...prev, createNotification: e }))

    }

    function updateCheckBoxOffsite(e) {
        setOffsite(e)
    }

    function getDataRule() {
        EntityService.getEntityRuleByEntityGroup(entityGroupId).then((value) => {
            setDataRule(value.data.data.rules)
            setPageName(value.data.data.groupName)
            setBehaviorName(value.data.data.groupName)
        })
        EntityService.getTenantEntityRules(entityGroupId).then((value) => {
            let rules = []
            for (let i = 0; i < value.data.data.length; i++) {
                rules.push(value.data.data[i].name)
            }
            setRuleLabel(rules)
        })

        EntityService.getSeverity().then((values) => {
            setSeverityLabel(values.data.data)
        })
        setBatteryData([{ name: '90%', value: 90 }, { name: '80%', value: 80 }, { name: '70%', value: 70 }, { name: '60%', value: 60 }, { name: '50%', value: 50 }, { name: '40%', value: 40 }, { name: '30%', value: 30 }, { name: '20%', value: 20 }, { name: '10%', value: 10 }])
    }

    function onRowInsertedRule(e) {
        EntityService.createEntityGroup(e.data.name).then((response) => {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                status: response.status,
                type: response?.status === 200 ? 'success' : 'error',
                message: response?.data?.message ? response.data.message : response.message,
            });
            getData()
        })
    }

    function onRowRemovedRule(e) {
        EntityService.deleteRuleFromEntityGroupRuleMap(e.data.id).then((response) => {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                status: response.status,
                type: response.status === 200 ? 'success' : 'error',
                message: response?.data?.message ? response.data.message : response.message,
            });
            getDataRule()
        })
    }

    function onRowUpdatingRule(e) {
        EntityService.editEntityGroup(e.newData.name, e.oldData.id).then((res) => {
            getDataRule()
        })
    }

    function createGroupMap() {
        let ruleId
        let ruleInfo
        let hasCheckIn = true
        if (formVisible === 'Gateway Offline') {
            ruleId = 5
            ruleInfo = {
                // "emailAlert": {
                //     "recipients": emails
                // },
                "severity": popupData.severity,
                "thresholdHours": popupData.thresholdHours,
                "retransmitPeriodHours": popupData.reTransmitPeriodHours,
                "createNotification": popupData.createNotification
            }
        }
        if (formVisible === 'Change State') {
            ruleId = 9
            ruleInfo = {
                "severity": popupData.severity,
                "detectionType": popupData.detectionType,
                "spaceId": popupData.selectedSpace2,
                "processState": popupData.processState,
                "createNotification": popupData.createNotification,
                "offsite": offsite
            }
        }
        if (formVisible === 'Geofence') {
            ruleId = 4
            ruleInfo = {
                "severity": popupData.severity,
                "spaceId": popupData.selectedSpace2,
                // "emailAlert": {
                //     "recipients": emails
                // },
                "detectionType": popupData.detectionType,
                "createNotification": popupData.createNotification
            }
        }
        if (formVisible === 'Device Offline') {
            ruleId = 2
            ruleInfo = {
                "severity": popupData.severity,
                "emailAlert": {
                    // "recipients": emails,
                    "transmitPeriodHours": 1,
                    "reTransmitPeriodHours": popupData.reTransmitPeriodHours
                },
                "thresholdHours": popupData.thresholdHours,
                "createNotification": popupData.createNotification
            }
        }
        if (formVisible === 'Battery Level') {
            ruleId = 7
            ruleInfo = {
                "severity": popupData.severity,
                "emailAlert": {
                    "thresholdHours": popupData.thresholdHours,
                    "reTransmitPeriodHours": popupData.reTransmitPeriodHours
                },
                "batteryLevel": popupData.batteryLevel,
                "createNotification": popupData.createNotification
            }
        }
        if (formVisible === 'Valmet Process') {
            ruleId = 3
            ruleInfo = {
                "severity": popupData.severity,
                // "emailAlert": {
                //     "recipients": emails,
                // },
                "createNotification": popupData.createNotification
            }
        }
        if (formVisible === 'Check In/Out') {
            if (data.some(e => e.ruleId === 1)) {
                hasCheckIn = false
            }
            ruleId = 1
            ruleInfo = {
            }
        }
        if (formVisible === 'Device Offsite') {
            ruleId = 6
            ruleInfo = {
                "severity": popupData.severity,
                // "emailAlert": {
                //     "recipients": emails
                // },
                "thresholdMinutes": popupData.thresholdMinutes,
                "createNotification": popupData.createNotification
            }
        }
        if (formVisible === 'Temperature Excursion') {
            ruleId = 10
            ruleInfo = {
                "severity": popupData.severity,
                "temperatureUnit": popupData.temperatureUnit,
                "temperatureThreshold": popupData.temperatureThreshold,
                "directionExcursion": popupData.directionExcursion,
                "suppressionWindow": popupData.suppressionWindow,
                "createNotification": popupData.createNotification
            }
        }
        if (formVisible === 'Tamper Detect') {
            ruleId = 11
            ruleInfo = {
                "severity": popupData.severity,
                "createNotification": popupData.createNotification
            }
        }
        if (popupData.editAdd === "edit") {
            let id = popupData.editId
            EntityService.editEntityGroupRuleMap(id, ruleId, ruleInfo, popupData.name).then((response) => {
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    status: response.status,
                    type: response.status === 200 ? 'success' : 'error',
                    message: response.data.message,
                });
                getDataRule()
            })
        }
        if (hasCheckIn && popupData.editAdd === "add") {
            EntityService.createEntityGroupRuleMap(entityGroupId, ruleId, ruleInfo, popupData.name).then((response) => {
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    status: response.status,
                    type: response.status === 200 ? 'success' : 'error',
                    message: response?.data?.message ? response.data.message : response.message,
                });
                getDataRule()
            })
        } else if (popupData.editAdd === "add") {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'error',
                status: 500,
                message: 'Check In/Out rule already exists',
                displayTime: 3000,
            });
        }
        setPopupVisibleRule(false)
    }

    function addOnClickRule() {
        // Reset form state when opening for new rule
        // setEditId(null)
        // setEditAdd("add")
        // setTransmitPeriodHours(null)
        // setReTransmitPeriodHours(null)
        // setProcessState(null)
        // setThresholdHours(null)
        // setThresholdMinutes(null)
        // setDetectionType("")
        // setRuleType(null)
        // setName(null)
        // setSelectedSpace2([])
        // setCreateNotification(true)
        // setEntityNotes("")
        // setSeverity(null)
        // setBatteryLevel("")
        // setDirectionExcursion("")
        // setSuppressionWindow("")
        // setTemperatureThreshold("")
        // setTemperatureUnit("")
        setFormVisible("")
        // setPopupVisibleRule(true)

        setPopupData({
            editId: null,
            editAdd: "add",
            transmitPeriodHours: null,
            reTransmitPeriodHours: null,
            processState: null,
            thresholdHours: null,
            thresholdMinutes: null,
            detectionType: "",
            ruleType: null,
            name: null,
            selectedSpace2: [],
            createNotification: true,
            entityNotes: "",
            severity: null,
            batteryLevel: "",
            directionExcursion: "",
            suppressionWindow: "",
            temperatureThreshold: "",
            temperatureUnit: "",
            formVisible: ""
        });

        setPopupVisibleRule(true);
    }

    function setForm(e) {
        if (e.dataField === "transmitPeriodHours") {
            // setTransmitPeriodHours(1)
            setPopupData(prev => ({ ...prev, transmitPeriodHours: 1 }))
        }
        if (e.dataField === "reTransmitPeriodHours") {
            // setReTransmitPeriodHours(e.value ? parseInt(e.value) : "")
            setPopupData(prev => ({ ...prev, reTransmitPeriodHours: (e.value ? parseInt(e.value) : "") }))
        }
        if (e.dataField === "thresholdHours") {
            // setThresholdHours(e.value ? parseInt(e.value) : "")
            setPopupData(prev => ({ ...prev, thresholdHours: (e.value ? parseInt(e.value) : "") }))
        }
        if (e.dataField === "detectionType") {
            // setDetectionType(e.value)
            setPopupData(prev => ({ ...prev, detectionType: e.value }))
        }
        if (e.dataField === "thresholdMinutes") {
            // setThresholdMinutes(e.value ? parseInt(e.value) : "")
            setPopupData(prev => ({ ...prev, thresholdMinutes: (e.value ? parseInt(e.value) : "") }))

        }
        if (e.dataField === "createNotification") {
            // setCreateNotification(e.value)
            setPopupData(prev => ({ ...prev, createNotification: e.value }))
        }
        if (e.dataField === "offsite") {
            setOffsite(e.value)
        }
        if (e.dataField === "batteryLevel") {
            // setBatteryLevel(e.value)
            setPopupData(prev => ({ ...prev, batteryLevel: e.value }))

        }
        if (e.dataField === "processState") {
            // setProcessState(e.value)
            setPopupData(prev => ({ ...prev, processState: e.value }))

        }
        if (e.dataField === "directionExcursion") {
            // setDirectionExcursion(e.value)
            setPopupData(prev => ({ ...prev, directionExcursion: e.value }))

        }
        if (e.dataField === "suppressionWindow") {
            // setSuppressionWindow(e.value)
            setPopupData(prev => ({ ...prev, suppressionWindow: e.value }))

        }
        if (e.dataField === "temperatureThreshold") {
            // setTemperatureThreshold(e.value)
            setPopupData(prev => ({ ...prev, temperatureThreshold: e.value }))

        }
        if (e.dataField === "temperatureUnit") {
            // setTemperatureUnit(e.value)
            setPopupData(prev => ({ ...prev, temperatureUnit: e.value }))

        }
    }

    function setRuleName(e) {
        // setName(e.value)
        setPopupData(prev => ({ ...prev, name: e.value }))

    }

    function onRuleChanged(e) {
        // setRuleType(e.value)
        setPopupData(prev => ({ ...prev, ruleType: e.value }))
        setFormVisible(e.value)
        setPopupData(prev => ({ ...prev, formVisible: e.value }))
        if (e.value === 'Gateway Offline') {
            // setEntityNotes("Note: This rule applies to the 'Gateway' entity only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Gateway' entity only." }))
        } else if (e.value === 'Check In/Out') {
            // setEntityNotes("Note: This rule applies to the 'Device' entity only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Device' entity only." }))
        } else if (e.value === 'Device Offline') {
            // setEntityNotes("Note: This rule applies to the 'Device' entity only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Device' entity only." }))
        } else if (e.value === 'Geofence') {
            // setEntityNotes("Note: This rule applies to the 'Device' and 'Asset' entity only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Device' and 'Asset' entity only." }))
        } else if (e.value === 'Device Offsite') {
            // setEntityNotes("Note: This rule applies to the 'Device' entity only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Device' entity only." }))
        } else if (e.value === 'Battery Level') {
            // setEntityNotes("Note: This rule applies to the 'Devices' with role Tag and Anchor only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Devices' with role Tag and Anchor only." }))
        } else if (e.value === 'Change State') {
            // setEntityNotes("Note: This rule applies to the 'Devices' entity only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Devices' entity only." }))
        } else if (e.value === 'Temperature Excursion') {
            // setEntityNotes("Note: This rule applies to the 'Devices' entity only.")
            setPopupData(prev => ({ ...prev, entityNotes: "Note: This rule applies to the 'Devices' entity only." }))
        }
    }

    function onSeverityChanged(e) {
        // setSeverity(e.value)
        setPopupData(prev => ({ ...prev, severity: e.value }))

    }

    useEffect(() => {
        getDataRule()
        getSpaceData()
    }, []);

    // function rulesText() {
    //     return (
    //         <>
    //             <i className="dx-icon-edit" style={{ "fontSize": "16px", "color": "#d71109" }}></i>
    //         </>
    //     )
    // }

    function buttonColor(e) {
        if ((e.column.caption === '') && e.rowType !== "header") {
            e.cellElement.style.setProperty('cursor', 'pointer', 'important')
        }
    }

    function showInfo(e) {
        console.log("in showInfo!");

        if (e.column.caption !== '') return;

        const info = e.data?.ruleInfo ?? {};
        const emailAlert = info.emailAlert ?? {};

        console.log("before updated obj")
        // Build all fields at once
        const updated = {
            editAdd: "edit",
            name: e.data.name,
            ruleType: e.data.ruleName,
            editId: e.data.id,
            formVisible: e.data.ruleName,
            severity: info.severity ?? null,
            reTransmitPeriodHours:
                emailAlert.reTransmitPeriodHours ??
                info.retransmitPeriodHours ??
                null,
            selectedSpace2: info.spaceId ?? [],
            thresholdHours:
                info.thresholdHours ??
                emailAlert.thresholdHours ??
                null,
            detectionType: info.detectionType ?? "",
            thresholdMinutes: info.thresholdMinutes ?? null,
            createNotification: info.createNotification ?? true,
            batteryLevel: info.batteryLevel ?? "",
            processState: info.processState ?? null,
            directionExcursion: info.directionExcursion ?? null,
            suppressionWindow: info.suppressionWindow ?? null,
            temperatureThreshold: info.temperatureThreshold ?? null,
            temperatureUnit: info.temperatureUnit ?? 1,
        };

        console.log("after updated obj")

        // ONE state update
        setPopupData(prev => ({
            ...prev,
            ...updated
        }));

        console.log("after setPopupData")

        setOffsite(info.offsite ?? false);

        console.log("after setOffsite")

        // After data is ready, show the form
        setPopupVisibleRule(true);
        setFormVisible(e.data.ruleName);
        // setPopupVisibleRule(true);
    }

    // function showInfo(e) { //@@@
    //     console.log(" in showinfo")
    //     if (e.column.caption === '') {
    //         // setPopupVisibleRule(true)
    //         // setFormVisible(e.data.ruleName)

    //         setPopupData(prev => ({
    //              ...prev, 
    //              editAdd: "edit",
    //              name: e.data.name,
    //              ruleType: e.data.ruleName,
    //              editId: e.data.id,
    //              formVisible: e.data.ruleName,
    //              severity: e.data.ruleInfo.severity
    //             }))

    //         if (e.data?.ruleInfo?.emailAlert?.reTransmitPeriodHours !== undefined) {
    //             setPopupData(prev => ({ ...prev, reTransmitPeriodHours: e.data.ruleInfo.emailAlert.reTransmitPeriodHours}))
    //         }
    //         if (e.data?.ruleInfo?.spaceId !== undefined) {
    //             setPopupData(prev => ({ ...prev, selectedSpace2: e.data.ruleInfo.spaceId }))
    //         }
    //         if (e.data?.ruleInfo?.retransmitPeriodHours !== undefined) {
    //             setPopupData(prev => ({ ...prev, reTransmitPeriodHours: e.data.ruleInfo.retransmitPeriodHours}))
    //         }
    //         if (e.data?.ruleInfo?.thresholdHours !== undefined) {
    //             setPopupData(prev => ({ ...prev, thresholdHours: e.data.ruleInfo.thresholdHours }))
    //         }
    //         if (e.data?.ruleInfo?.emailAlert?.thresholdHours !== undefined) {
    //             setPopupData(prev => ({ ...prev, thresholdHours: e.data.ruleInfo.emailAlert.thresholdHours }))
    //         }
    //         if (e.data?.ruleInfo?.detectionType !== undefined) {
    //             setPopupData(prev => ({ ...prev, detectionType: e.data.ruleInfo.detectionType }))
    //         }
    //         if (e.data?.ruleInfo?.thresholdMinutes !== undefined) {
    //             setPopupData(prev => ({ ...prev, thresholdMinutes: e.data.ruleInfo.thresholdMinutes }))
    //         }
    //         if (e.data?.ruleInfo?.createNotification !== undefined) {
    //             setPopupData(prev => ({ ...prev, createNotification: e.data.ruleInfo.createNotification }))
    //         }
    //         if (e.data?.ruleInfo?.offsite !== undefined) {
    //             setOffsite(e.data.ruleInfo.offsite)
    //         }
    //         if (e.data?.ruleInfo?.batteryLevel !== undefined) {
    //             setPopupData(prev => ({ ...prev, batteryLevel: e.data.ruleInfo.batteryLevel }))
    //         }
    //         if (e.data?.ruleInfo?.processState !== undefined) {
    //             setPopupData(prev => ({ ...prev, processState: e.data.ruleInfo.processState }))
    //         }
    //         if (e.data?.ruleInfo?.directionExcursion !== undefined) {
    //             setPopupData(prev => ({ ...prev, directionExcursion: e.data.ruleInfo.directionExcursion }))
    //         }
    //         if (e.data?.ruleInfo?.suppressionWindow !== undefined) {
    //             setPopupData(prev => ({ ...prev, suppressionWindow: e.data.ruleInfo.suppressionWindow }))
    //         }
    //         if (e.data?.ruleInfo?.temperatureThreshold !== undefined) {
    //             setPopupData(prev => ({ ...prev, temperatureThreshold: e.data.ruleInfo.temperatureThreshold }))
    //         }
    //         if (e.data?.ruleInfo?.temperatureUnit !== undefined) {
    //             setPopupData(prev => ({ ...prev, temperatureUnit: e.data.ruleInfo.temperatureUnit }))
    //         }
    //         setFormVisible(e.data.ruleName)
    //         setPopupVisibleRule(true)
    //     }
    // }

    function backClick() {
        // setPopupVisibleRule(false)
        // // Reset all form state variables when closing
        // setEditId(null)
        // setEditAdd("add")
        // setTransmitPeriodHours(null)
        // setReTransmitPeriodHours(null)
        // setProcessState(null)
        // setThresholdHours(null)
        // setThresholdMinutes(null)
        // setDetectionType("")
        // setRuleType(null)
        // setName(null)
        // setSelectedSpace2([])
        // setCreateNotification(true)
        // setEntityNotes("")
        // setSeverity(null)
        // setBatteryLevel("")
        // setDirectionExcursion("")
        // setSuppressionWindow("")
        // setTemperatureThreshold("")
        // setTemperatureUnit("")
        setFormVisible("")

        setPopupVisibleRule(false);

        setPopupData({
            editId: null,
            editAdd: "add",
            transmitPeriodHours: null,
            reTransmitPeriodHours: null,
            processState: null,
            thresholdHours: null,
            thresholdMinutes: null,
            detectionType: "",
            ruleType: null,
            name: null,
            selectedSpace2: [],
            createNotification: true,
            entityNotes: "",
            severity: null,
            batteryLevel: "",
            directionExcursion: "",
            suppressionWindow: "",
            temperatureThreshold: "",
            temperatureUnit: "",
            formVisible: ""
        });
    }

    function backClickEntities() {
        setPopupVisible2(false);
        // setRuleType("");
        setPopupData(prev => ({ ...prev, ruleType: "" }))
        setListData([]);
        setSelectedItems([]);
    }

    function backClickBehavior() {
        setbehaviorPopupVisible(false)
        setBehaviorName(pageName) // Reset to original value when closing
    }

    function updateBehaviorName(e) {
        console.log('VAL OF E: ', e);
        console.log('entityGroupId: ', entityGroupId)
        EntityService.editEntityGroup(behaviorName, entityGroupId).then((res) => {
            getData()
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: res.status === 200 ? 'success' : 'error',
                status: res?.data?.status ? res.data.status : res?.status,
                message: res?.data?.message ? res.data.message : res?.message,
            });
        })
        setbehaviorPopupVisible(false)
    }

    function handleBehaviorNameChange(e) {
        setBehaviorName(e.value)
    }

    return (
        <>
            <SlidingDrawer
                isOpen={behaviorPopupVisible}
                onClose={backClickBehavior}
                title="Behavior"
                showFooter={true}
                handleSave={updateBehaviorName}
                formData={{ name: behaviorName }}
                prevData={{ name: pageName }}
            >
                <div className="field">
                    <div className="label">Behavior Name *</div>
                    <div className="value">
                        <TextBox
                            value={behaviorName}
                            onValueChanged={handleBehaviorNameChange}
                            maxLength={40}
                            valueChangeEvent="keyup"
                        />
                        <RequiredRule></RequiredRule>
                    </div>
                </div>
            </SlidingDrawer>

            <SlidingDrawer
                isOpen={popupVisible2}
                onClose={backClickEntities}
                title="Select Entities"
                showFooter={false}
                formData={{}}
                prevData={{}}
            >
                <SelectBox
                    items={['Assets', 'Devices', 'Gateways']}
                    value={popupData.ruleType}
                    visible={((popupData.ruleType !== 'Assets') && (popupData.ruleType !== 'Devices') && (popupData.ruleType !== 'Gateways'))}
                    onValueChanged={onEntitySelection}
                    placeholder="Select Entity Type"
                    dropDownOptions={{ container: '.slide-pane' }}
                />
                <DataGrid
                    dataSource={listData}
                    height={"90%"}
                    displayExpr={"name"}
                    visible={((popupData.ruleType === 'Assets') || (popupData.ruleType === 'Devices') || (popupData.ruleType === 'Gateways'))}
                    onSelectionChanged={onOptionChanged}
                    allowColumnResizing={true}
                    dropDownOptions={{ container: '.slide-pane' }}
                >
                    <Selection
                        mode="multiple"
                        selectAllMode={'allPages'}
                        showCheckBoxesMode={'always'}
                    />
                    <FilterRow visible={true} />
                    {/* <HeaderFilter visible="showHeaderFilter" /> */}
                    <HeaderFilter visible={true} />
                    <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
                    <Paging enabled={false} />
                    <Column dataField="name" visible={(popupData.ruleType === 'Assets') || (popupData.ruleType === 'Gateways')} />
                    <Column dataField="type.name" visible={(popupData.ruleType === 'Assets')} />
                    <Column dataField="lastKnownLocation.name" caption="Space" visible={(popupData.ruleType === 'Assets')} />
                    <Column dataField="serialNumber" visible={(popupData.ruleType === 'Devices')} />
                    <Column dataField="type" visible={(popupData.ruleType === 'Devices')} />
                    <Column dataField="role.name" visible={(popupData.ruleType === 'Devices')} />
                    <Column dataField="space.name" visible={(popupData.ruleType === 'Devices')} />
                    <Column dataField="status" visible={(popupData.ruleType === 'Gateways')} cellRender={({ value }) => (<span>{value ? "Online" : "Offline"}</span>)} />
                </DataGrid>
                <div className="entityGroup-setEntities" onClick={createGroupMapEntities} style={{ marginRight: "2%" }}>
                    ADD
                </div>
                <div className="entityGroup-setEntitiesCancel" onClick={backClickEntities}>
                    CANCEL
                </div>
            </SlidingDrawer>

            <div className='headerHeadingPage fixLayout' >
                <div className='pageFullWidthEvents'>

                    <div className='editentities_col'>
                        <div style={{ marginTop: "0px", fontSize: "20px", display: "inline-block" }}><b> Behavior: {pageName}</b></div>
                        <i className="dx-icon-edit" onClick={openBehaviorEditPopup} style={{ marginLeft: "10px", fontSize: "20px", "color": "#d71109", cursor: "pointer" }}></i>
                    </div>


                    <div className='editentities_col'>
                        <div style={{ fontSize: "20px", display: "inline-block", marginTop: "30px" }}><b>Entities:</b></div>
                        <i className="entity-group-add dx-icon-close" onClick={closeTenant} style={{ top: "10px" }}></i>
                        <i onClick={addOnClick} id="addTenantButton" className="entity-group-add dx-icon-add addBtn" style={{ "fontSize": "24px", "right": "280px" }}>
                            <Tooltip
                                target="#addTenantButton"
                                showEvent="mouseenter"
                                hideEvent="mouseleave"
                                position="bottom"
                            >
                                <div className="custom-tooltip">Add an Entity</div>
                            </Tooltip>
                        </i>
                    </div>

                    <EntitiesGrid
                        data={data}
                        onRowInserted={onRowInserted}
                        onRowRemoved={onRowRemoved}
                    />
                </div>
            </div>

            {/* Rules of Behavior */}

            <div className='headerHeadingPage fixLayout'>
                <div className='pageFullWidthEvents-rule'>
                    <div className='editentities_col-rule'>
                        <div style={{ fontSize: "20px", display: "inline-block" }}><b>Rules:</b></div>
                        {/* <i className="entity-group-add dx-icon-close" onClick={closeTenantRule}></i> */}
                        <i onClick={addOnClickRule} id="addTenantRuleButton" className="entity-group-add dx-icon-add addBtn2" style={{ "fontSize": "24px" }}>
                            <Tooltip
                                target="#addTenantRuleButton"
                                showEvent="mouseenter"
                                hideEvent="mouseleave"
                                position="bottom"
                            >
                                <div className="custom-tooltip">Add a Rule</div>
                            </Tooltip>
                        </i>
                    </div>
                    <DataGrid
                        id="entity-rule-map-grid-rule"
                        ref={dropDataGridRefRule}
                        showColumnLines={false}
                        showRowLines={true}
                        onRowInserted={onRowInsertedRule}
                        onRowRemoved={onRowRemovedRule}
                        onRowUpdating={onRowUpdatingRule}
                        onCellClick={showInfo}
                        onCellPrepared={buttonColor}
                        // height={'calc(100vh - 525px)'}
                        // height={height}
                        allowColumnResizing={true}
                        dataSource={dataRule}>
                        <Paging enabled="false" />
                        <FilterRow visible="true" apply-filter="true" />
                        <HeaderFilter visible="showHeaderFilter" />
                        <SearchPanel visible="true" width="240" placeholder="Search..." />
                        <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
                        <Editing
                            allowDeleting={true}
                            use-icons={true}
                            mode="popup"
                            width={10}
                            texts={{
                                addRow: 'Add Rule',
                                confirmDeleteMessage: "Are you sure you want to delete this Rule?"
                            }}
                        >
                        </Editing>
                        <Column
                            dataField={'name'}
                            caption={"Rule Name"}
                            hidingPriority={8}
                        >
                            <RequiredRule />
                        </Column>
                        <Column
                            dataField={'ruleName'}
                            hidingPriority={8}
                            caption={"Rule type"}
                        >
                            <RequiredRule />
                        </Column>
                        <Column
                            caption={''}
                            width={20}
                            cellRender={rulesText}
                        ></Column>
                    </DataGrid>
                </div>
            </div>

            <SlidingDrawer
                isOpen={popupVisibleRule}
                onClose={backClick}
                title="Configure Rule"
                showFooter={false}
                formData={{}}
                prevData={{}}
            >
                <ScrollView className='custom_form_scroll' height={'80%'} >
                    <div className='entityRuleMap-name' style={{ paddingBottom: "12px" }}>
                        <Form2
                            labelLocation={"left"}
                            labelMode={"outside"}
                            id={'form'}
                            formData={{
                                "name": popupData.name,
                            }}
                            onFieldDataChanged={setRuleName}
                        >
                            <Item2 dataField={"name"} editorOptions={{
                                elementAttr: {
                                    class: 'rule-name-input' // Apply the custom CSS class
                                }
                            }}>
                            </Item2>
                        </Form2>
                    </div>
                    <div className='entityRuleMap-select' style={{ paddingBottom: "20px" }}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"18%", paddingTop:"15px"}}
                        >Rule&nbsp;Type</span>
                        <SelectBox
                            items={ruleLabel}
                            value={popupData.ruleType}
                            // height={40}
                            className='custom_select'
                            onValueChanged={onRuleChanged}
                            placeholder="Select Rule Type"
                            dropDownOptions={{ container: '.slide-pane' }}
                        />
                    </div>
                    <div className='severity-select entityRuleMap-select'>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"19%", paddingTop:"15px"}}
                        >Severity</span>
                        <SelectBox
                            placeholder="Select severity"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={severityLabel}
                            value={popupData.severity}
                            onValueChanged={onSeverityChanged}
                            valueExpr="id"
                            displayExpr="name"
                            dropDownOptions={{ container: '.slide-pane' }}
                        >
                        </SelectBox>
                    </div>
                    <div className={formVisible === 'Geofence' || formVisible === 'Change State' ? 'entityRuleMap-space entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"18%", paddingTop:"15px"}}
                        >Select&nbsp;Space</span>
                        <SelectBox
                            placeholder="Select a Space"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={spaces}
                            value={popupData.selectedSpace2}
                            onValueChanged={onValueChanged2}
                            valueExpr="id"
                            displayExpr="name"
                            dropDownOptions={{ container: '.slide-pane' }}
                            visible={(formVisible === 'Geofence' || formVisible === 'Change State')}
                        >
                        </SelectBox>
                    </div>
                    <div className={formVisible === 'Temperature Excursion' ? 'entityRuleMap-space entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span className='custom_label'>Temperature&nbsp;Unit</span>
                        <SelectBox
                            placeholder="Temperature Unit"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={[{ id: 1, name: "°F (Fahrenheit)" }, { id: 2, name: "°C (Celcius)" }]}
                            value={popupData.temperatureUnit}
                            onValueChanged={onTemperatureUnit}
                            valueExpr="id"
                            displayExpr="name"
                            dropDownOptions={{ container: '.slide-pane' }}
                            visible={(formVisible === 'Temperature Excursion')}
                            defaultValue={1}
                        >
                        </SelectBox>
                    </div>

                    {/* Add Temperature Threshold input box */}
                    <div className={formVisible === 'Temperature Excursion' ? 'entityRuleMap-space entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"8%", paddingTop:"15px"}}
                        >Temperature&nbsp;Threshold</span>
                        <TextBox
                            placeholder="Enter Temperature Threshold"
                            value={popupData.temperatureThreshold}
                            onValueChanged={onTemperatureThreshold}
                            maxLength={10}
                            visible={(formVisible === 'Temperature Excursion')}
                            width={500}
                            // height={40}
                            className='custom_select'
                            onKeyPress={(e) => {
                                const charCode = e.event.charCode;
                                const regex = /^-?\d*\.?\d*$/; // Regex to allow positive, negative, and float values
                                const char = String.fromCharCode(charCode);
                                if (!regex.test(char) && charCode !== 45 && charCode !== 46) { // Allow '-' and '.'
                                    e.event.preventDefault(); // Prevent invalid input
                                }
                            }}
                        />
                    </div>

                    <div className={formVisible === 'Temperature Excursion' ? 'entityRuleMap-space entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"9%", paddingTop:"15px"}}
                        >Direction&nbsp;of&nbsp;Excursion</span>
                        <SelectBox
                            placeholder="Select Direction of Excursion"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={[{ id: 1, name: "Overshoot" }, { id: 2, name: "Undershoot" }]}
                            value={popupData.directionExcursion}
                            onValueChanged={onDirectionExcursion}
                            valueExpr="id"
                            displayExpr="name"
                            dropDownOptions={{ container: '.slide-pane' }}
                            defaultValue={1}
                            visible={(formVisible === 'Temperature Excursion')}
                        >
                        </SelectBox>
                    </div>
                    <div className={formVisible === 'Temperature Excursion' ? 'entityRuleMap-space entityRuleMap-select' : 'entityRuleMap-spaceNone'} style={{ paddingBottom: '0px', marginBottom: '0px' }}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"10%", paddingTop:"15px"}}
                        >Suppression&nbsp;Window</span>
                        <SelectBox
                            placeholder="Suppression Window"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={[{ id: 1, name: "None" }, { id: 2, name: "30 s" }, { id: 3, name: "1 min" },
                            { id: 4, name: "2 min" }, { id: 5, name: "5 min" }, { id: 6, name: "10 min" },
                            { id: 7, name: "20 min" }, { id: 8, name: "1 hour" }, { id: 9, name: "2 hours" },
                            { id: 10, name: "5 hours" }, { id: 11, name: "12 hours" }, { id: 12, name: "1 day" }]}
                            value={popupData.suppressionWindow}
                            onValueChanged={onSuppressionWindow}
                            valueExpr="id"
                            displayExpr="name"
                            defaultValue={1}
                            dropDownOptions={{ container: '.slide-pane' }}
                            visible={(formVisible === 'Temperature Excursion')}
                        >
                        </SelectBox>
                    </div>

                    <div className={formVisible === 'Battery Level' ? 'entityRuleMap-space entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"18%", paddingTop:"15px"}}
                        >Select&nbsp;Battery</span>
                        <SelectBox
                            placeholder="Select Battery Level"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={batteryData}
                            value={popupData.batteryLevel}
                            onValueChanged={onValueChangedBattery}
                            valueExpr="value"
                            displayExpr="name"
                            dropDownOptions={{ container: '.slide-pane' }}
                            visible={(formVisible === 'Battery Level')}
                        >
                        </SelectBox>
                    </div>

                    <div className={formVisible === 'Geofence' ? 'entityRuleMap-space2 entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"16%", paddingTop:"15px"}}
                        >Detection&nbsp;Type</span>
                        <SelectBox
                            placeholder="Select a Detection Type"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={[{ id: 'inside', name: 'Enters' }, { id: 'outside', name: 'Exits' }]}
                            value={popupData.detectionType}
                            onValueChanged={onValueChangedDetection}
                            valueExpr="id"
                            displayExpr="name"
                            dropDownOptions={{ container: '.slide-pane' }}
                            visible={(formVisible === 'Geofence')}
                        >
                        </SelectBox>
                    </div>
                    <div className={formVisible === 'Change State' ? 'entityRuleMap-space2 entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span className='custom_label'
                        // style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"16%", paddingTop:"15px"}}
                        >Detection&nbsp;Type</span>
                        <SelectBox
                            placeholder="Select a Detection Type"
                            focusStateEnabled={false}
                            // height={40}
                            className='custom_select'
                            items={[{ id: 'ENTERED', name: 'Entered' }, { id: 'EXITED', name: 'Exited' }]}
                            value={popupData.detectionType}
                            onValueChanged={onValueChangedDetection}
                            valueExpr="id"
                            displayExpr="name"
                            dropDownOptions={{ container: '.slide-pane' }}
                            visible={(formVisible === 'Change State')}
                        >
                        </SelectBox>
                    </div>
                    <Form2
                        labelLocation={"left"}
                        labelMode={"outside"}
                        id={'form'}
                        className='process-state-form'
                        formData={{
                            "processState": popupData.processState,
                            "createNotification": popupData.createNotification
                        }}
                        onFieldDataChanged={setForm}
                        visible={(formVisible === 'Change State')}
                    >
                        <Item2 dataField={"processState"} label={processStateLabel} editorType="dxTextBox"
                            editorOptions={{
                                elementAttr: {
                                    class: 'process-state-input' // Apply the custom CSS class
                                }
                            }} cssClass={"process-state-label"}></Item2>
                    </Form2>

                    <div className={(formVisible === 'Geofence' || formVisible === 'Temperature Excursion' || formVisible === 'Change State' || formVisible === 'Tamper Detect' ) ? 'entityRuleMap-space2 entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span style={{ fontSize: "12px", color: "rgba(117,117,117,.87)", paddingRight: "12%", paddingTop: "40px" }}>Create&nbsp;Notification!</span>
                        <CheckBox defaultValue={true} value={popupData.createNotification} onValueChange={updateCheckBoxValue} style={{ fontSize: "12px", color: "rgba(117,117,117,.87)", paddingLeft: "0px", paddingTop: "40px" }}></CheckBox>
                    </div>
                    <div className={formVisible === 'Change State' && popupData.detectionType === 'EXITED' ? 'entityRuleMap-space2 entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span style={{ fontSize: "12px", color: "rgba(117,117,117,.87)", paddingRight: "23%", paddingTop: "40px" }}>Offsite</span>
                        <CheckBox id="offsite" defaultValue={true} onValueChange={updateCheckBoxOffsite} style={{ fontSize: "12px", color: "rgba(117,117,117,.87)", paddingLeft: "0px", paddingTop: "40px" }}></CheckBox>
                        <Tooltip
                            target="#offsite"
                            showEvent="mouseenter"
                            hideEvent="mouseleave"
                            position="right"
                            hideOnOutsideClick={false}
                        >When selected, the rule only triggers if the Asset or Device left the tracking area through the selected Space.
                        </Tooltip>
                    </div>
                    <Form2
                        labelLocation={"left"}
                        labelMode={"outside"}
                        id={'form'}
                        formData={{
                            "thresholdHours": popupData.thresholdHours,
                            "reTransmitPeriodHours": popupData.reTransmitPeriodHours,
                            // "transmitPeriodHours": transmitPeriodHours,
                            "createNotification": popupData.createNotification
                        }}
                        onFieldDataChanged={setForm}
                        visible={(formVisible === 'Device Offline')}
                        style={{ paddingTop: "10px" }}
                    >
                        <Item2 dataField={"thresholdHours"} label={thresholdHoursLabel} editorOptions={{
                            elementAttr: {
                                class: 're-transmit-input-hours' // Apply the custom CSS class
                            }
                        }}>
                        </Item2>
                        <Item2 dataField={"reTransmitPeriodHours"} label={reTransmitPeriodHoursLabel} editorOptions={{
                            elementAttr: {
                                class: 're-transmit-input-hours' // Apply the custom CSS class
                            }
                        }}>
                        </Item2>
                        <Item2 dataField={"createNotification"} label={popupData.createNotification}>
                        </Item2>
                        {/* <Item2 dataField={"transmitPeriodHours"}>
                    </Item2> */}
                    </Form2>
                    <Form2
                        labelLocation={"left"}
                        labelMode={"outside"}
                        id={'form'}
                        formData={{
                            "thresholdHours": popupData.thresholdHours,
                            "reTransmitPeriodHours": popupData.reTransmitPeriodHours,
                            // "transmitPeriodHours": transmitPeriodHours,
                            "createNotification": popupData.createNotification
                        }}
                        onFieldDataChanged={setForm}
                        visible={(formVisible === 'Battery Level')}
                    >
                        <Item2 dataField={"thresholdHours"} label={thresholdHoursLabel} editorOptions={{
                            elementAttr: {
                                class: 're-transmit-input-hours' // Apply the custom CSS class
                            }
                        }}>
                        </Item2>
                        <Item2 dataField={"reTransmitPeriodHours"} label={reTransmitPeriodHoursLabel} editorOptions={{
                            elementAttr: {
                                class: 're-transmit-input-hours' // Apply the custom CSS class
                            }
                        }}>
                        </Item2>
                        <Item2 dataField={"createNotification"} label={popupData.createNotification}>
                        </Item2>
                        {/* <Item2 dataField={"transmitPeriodHours"}>
                    </Item2> */}
                    </Form2>
                    <Form2
                        labelLocation={"left"}
                        labelMode={"outside"}
                        id={'form'}
                        formData={{
                            "thresholdHours": popupData.thresholdHours,
                            "reTransmitPeriodHours": popupData.reTransmitPeriodHours,
                            "createNotification": popupData.createNotification
                        }}
                        onFieldDataChanged={setForm}
                        visible={(formVisible === 'Gateway Offline')}
                    >
                        <Item2 dataField={"thresholdHours"} label={thresholdHoursLabel} editorOptions={{
                            elementAttr: {
                                class: 're-transmit-input-hours' // Apply the custom CSS class
                            }
                        }}>
                        </Item2>
                        <Item2 dataField={"reTransmitPeriodHours"} label={reTransmitPeriodHoursLabel} editorOptions={{
                            elementAttr: {
                                class: 're-transmit-input-hours' // Apply the custom CSS class
                            }
                        }}>
                        </Item2>
                        <Item2 dataField={"createNotification"} label={popupData.createNotification} >
                        </Item2>
                    </Form2>
                    <Form2
                        labelLocation={"left"}
                        labelMode={"outside"}
                        id={'form'}
                        formData={{
                            "thresholdMinutes": popupData.thresholdMinutes
                        }}
                        onFieldDataChanged={setForm}
                        visible={(formVisible === 'Device Offsite')}
                    >
                        <Item2 dataField={"thresholdMinutes"} editorOptions={{
                            elementAttr: {
                                class: 'process-state-input-minutes' // Apply the custom CSS class
                            }
                        }}></Item2>
                    </Form2>
                    <div className={formVisible === 'Device Offsite' ? 'entityRuleMap-space2 entityRuleMap-select' : 'entityRuleMap-spaceNone'}>
                        <span style={{ fontSize: "12px", color: "rgba(117,117,117,.87)", paddingRight: "12%", paddingTop: "40px" }}>Create&nbsp;Notification</span>
                        <CheckBox defaultValue={true} onValueChange={updateCheckBoxValue} style={{ fontSize: "12px", color: "rgba(117,117,117,.87)", paddingLeft: "0px", paddingTop: "40px" }}></CheckBox>
                    </div>
                    <Form2>
                        <Item2></Item2>
                    </Form2>
                    {/* <div className='entityRuleMap-email'>
                    <Form2
                        labelLocation={"left"}
                        labelMode={"outside"}
                        id={'form'}
                        onFieldDataChanged={setFormEmail}
                        formData={emailFormData}
                        visible={((formVisible === 'Gateway Offline') || (formVisible === 'Geofence') || (formVisible === 'Valmet Process') || (formVisible === 'Device Offline') || (formVisible === 'Device Offsite'))}
                    >
                    </Form2>
                </div> */}
                    {/* <div style={{ height: '25px', width: '100%' }}>
                    {myList()}
                </div> */}
                </ScrollView>
                <div>
                    <div className='entityGroup-setNote'>{popupData.entityNotes}</div>
                    <div className={popupData.editAdd === "edit" ? "entityGroup-setEntities" : "entityRuleMap-spaceNone"} style={{ marginRight: "2%" }} onClick={createGroupMap}>
                        SAVE
                    </div>
                    <div className={popupData.editAdd === "add" ? "entityGroup-setEntities" : "entityRuleMap-spaceNone"} style={{ marginRight: "2%" }} onClick={createGroupMap}>
                        ADD
                    </div>
                    <div onClick={backClick} className={"entityGroup-setEntitiesCancel"}>
                        CANCEL
                    </div>
                </div>
            </SlidingDrawer>
            <Toast
                setParentToastConfig={setToastConfig}
                toastBody={toastConfig}
            />
        </>
    );
}
